document.querySelectorAll('.field-password svg').forEach((eye_icon) => {
    eye_icon.addEventListener('click', () => {
        const password_input = eye_icon.closest('.field-password').querySelector('input');
        if (password_input.type === 'password') {
        password_input.type = 'text';
        } else {
        password_input.type = 'password';
        }
    });
});